import React from "react"
import * as Sentry from "@sentry/react"

const dsn = document.querySelector('meta[name="sentry-dsn"]')?.content

if (dsn) {
  Sentry.init({
    dsn,
    environment: document.querySelector('meta[name="app-environment"]')?.content || "production",
    tracesSampleRate: Number(document.querySelector('meta[name="sentry-traces-sample-rate"]')?.content || 0),
    sendDefaultPii: false,
  })
}

export function AppErrorBoundary({ children }) {
  return <Sentry.ErrorBoundary fallback={({ resetError }) => <main className="error-fallback"><p className="eyebrow">Something went wrong</p><h1>The clubhouse hit an error.</h1><p>Try reloading this screen. If it keeps happening, the error has been recorded for the team.</p><button className="button button--primary" onClick={resetError}>Try again</button></main>}>{children}</Sentry.ErrorBoundary>
}
